<template>
    <div>
        <Ui-Date-Picker-Range
            id="calendar"
            v-model="calendar"
            @input="getCalendarNews($event)"
        ></Ui-Date-Picker-Range>
    </div>
</template>

<script>
    import axios from 'axios';
    import { ref, watch, computed } from 'vue';
    import { useStore } from '../../store';
    import { showMoreCheckout } from './services/showMoreCheckout';
    import { resetNews } from './services/resetNews';
    import { getNews } from './services/getNews';
    import { getUrl } from './services/getUrl';

    export default {
        name: "pressCalendar",
        setup() {
            let calendar = ref(['']);
            const store = useStore();

            let stateCalendar = computed(() => {
                return store.state.press.calendar;
            });

            watch(stateCalendar , (val) => {
                calendar.value = val;
            });

            const getCalendarNews = (val) => {
                store.commit('press/SET_CALENDAR_VAL', val);
                store.commit('press/SET_LOADING', true);
                store.commit('press/SET_PAGE_NUMBER', 1);
                let url = getUrl();

                if (!val[0]) {
                    resetNews();
                    getNews();
                }
                else {
                    axios.get(url)
                        .then(res => {
                            if (res.data.meta.totalPages < 1) {
                                store.commit('press/SET_SEARCH_ERROR', true);
                            }
                            else {
                                store.commit('press/SET_SEARCH_ERROR', false);
                                showMoreCheckout(res.data.meta.totalPages);
                                store.commit('press/SET_NEWS', res.data.data);
                            }
                        })
                        .finally(()=> {
                            store.commit('press/SET_LOADING', false);
                        })
                }
            }

            return {
                calendar,
                stateCalendar,
                getCalendarNews
            };

        },
    }
</script>

<style scoped>
    .mx-datepicker-range {
        width: 100%;
    }
</style>
